import axios, { type AxiosInstance } from 'axios'
import Cookies from 'js-cookie'
import { env } from '../config/env'

const apiClient: AxiosInstance = axios.create({
  baseURL: env.apiBaseUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const getTokenFromCookie = (): string | undefined => {
  let token = Cookies.get('auth._token.local')
  if (token && token.startsWith('Bearer ')) {
    token = token.replace('Bearer ', '')
  }
  return token
}

const redirectToLogin = (): void => {
  const currentUrl = window.location.href
  const loginUrl = `${env.fleshDomain}/login?redirect=${encodeURIComponent(currentUrl)}`
  window.location.href = loginUrl
}

apiClient.interceptors.request.use(
  config => {
    const token = getTokenFromCookie()

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      redirectToLogin()
    }
    return Promise.reject(error)
  }
)

export default apiClient
